import { Routes, Route, Navigate } from "react-router-dom";
import BuyerDashboard from "./BuyerDashboard";

// Buyer Pages
import OrdersPage from "../pages/OrderPage";
import ProfilePage from "../pages/ProfilePage";
import AddressesPage from "../pages/AddressesPage";
import SecurityPage from "../pages/SecurityPage";
import SettingsPage from "../pages/SettingsPage";
import NotificationsPage from "../pages/NotificationsPage";
import SellerRequestPage from "../pages/SellerRequestPage";
import SupportPage from "../pages/SupportPage";
import NotFound from "../../../components/NotFound";

export default function BuyerRoutes() {
  return (
    <Routes>
      {/* BUYER DASHBOARD */}
      <Route path="/" element={<BuyerDashboard />}>
        <Route index element={<Navigate to="orders" replace />} />
        <Route path="orders" element={<OrdersPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="addresses" element={<AddressesPage />} />
        <Route path="security" element={<SecurityPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="seller-request" element={<SellerRequestPage />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
